import CxDropdownItem from '../Dropdown/dropdown-item.vue'

export default CxDropdownItem



// WEBPACK FOOTER //
// ./src/components/DropdownItem/index.js